<template>
  <div>
    <!-- 搜索 -->
    <table-search
      v-if="type!=='today-trade'"
      @search="fetchList(1)"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <el-form-item label="仓库编号">
          <el-input
            v-model.trim="query.warehouseNoLike"
          />
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model.trim="query.warehouseNameLike" />
        </el-form-item>
      </template>
    </table-search>
    <el-button
      v-if="type!=='select'"
      class="m-t-10"
      type="primary"
      @click="toCreate('add')"
    >
      新增
    </el-button>
    <!-- 导出 -->
    <inquery-result
      :is-export="false"
    />
    <el-table
      :data="warehouseData"
      border
      @row-click="handleRowClick"
    >
      <el-table-column
        v-if="type==='select'"
        width="60"
      >
        <template slot-scope="scope">
          <el-radio-group
            v-model="selectedRowId"
            class="m-l-5"
          >
            <el-radio
              :label="scope.row.id"
              @change="handleChangeSelectRow(scope.row, scope.row.id)"
            >
              {{ '' }}
            </el-radio>
          </el-radio-group>
        </template>
      </el-table-column>
      <el-table-column
        prop="warehouseNo"
        label="仓库编号"
      />
      <el-table-column
        prop="warehouseName"
        label="名称"
      />
      <el-table-column
        prop="address"
        label="所在地"
        :show-overflow-tooltip="type === 'select'"
      />

      <el-table-column
        prop="marketName"
        label="市场"
      />
      <el-table-column
        label="地理位置"
      >
        <template v-slot="scope">
          ({{ scope.row.lng }}，{{ scope.row.lat }})
        </template>
      </el-table-column>
      <el-table-column
        v-if="type!=='select'"
        prop="status"
        label="状态"
      >
        <template v-slot="scope">
          {{ scope.row.status | keyFilter('myStore', 'status') }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="type!=='select'"
        prop="lastUpdateDate"
        label="更新时间"
      />
      <el-table-column
        v-if="type!=='select'"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            class="m-l-10"
            @click="toCreate('edit',scope.row)"
          >
            编辑
          </el-button>
          <el-button
            type="text"
            class="m-l-10 red"
            @click="toDelete(scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :data="pageData"
      :is-init="false"
      @retrieve="fetchList"
    />
    <warehouse-create
      v-if="callCreate.visible"
      :call-create="callCreate"
      :market-list="marketList"
      @close="callCreate.visible=false"
      @refresh="fetchList"
    />
  </div>
</template>

<script>
import api from '@/api/'
// import Util from '@/utils'
import WarehouseCreate from './components/handle-warehouse'

function Query () {
  return {
    warehouseNameLike: '',
    warehouseNoLike: '',
    currentNo: '1',
    pageSize: '10',
    status: '',
    maeketId: '',
    warehouseType: 'WHOLESALER_APP'// 店铺仓库类型
  }
}
export default {
  name: 'WarehouseList',
  components: {
    WarehouseCreate,
  },
  props: {
    // select表示时选择某一项
    type: {
      type: String,
      default: '',
    },
    // el-card阴影
    shadow: {
      type: String,
      default: 'always',
    },
    // 用于货转选择仓库设置回显
    callWarehouse: {
      type: Object,
      default: () => { return { visible: false, warehouseNameLike: '', id: '', warehouseNoLike: '' } },
    },
  },
  data () {
    return {
      pageData: {},
      query: new Query(),
      warehouseData: [],
      marketList: [],
      callCreate: {
        visible: false,
        type: '',
        detailInfo: {},
      },
      selectedRowId: '',

    }
  },
  watch: {
    'callWarehouse.visible' (val) {
      if (val) {
        this.selectedRowId = this.callWarehouse.id
        this.query.warehouseNameLike = this.callWarehouse.warehouseNameLike
        this.query.warehouseNoLike = this.callWarehouse.warehouseNoLike
        this.fetchList(1)
      }
    },
  },
  async created () {
    this.type !== 'select' && await this.getMarketList()
    this.fetchList()
  },

  methods: {
    async getMarketList () {
      const res = await api.common.getMarketList()
      this.marketList = res.data
    },
    handleRowClick (row) {
      this.handleChangeSelectRow(row, row.id)
    },
    handleChangeSelectRow (row, id) {
      this.selectedRowId = id
      this.$emit('returnSelectedRowData', row)
    },
    fetchList (currentNo, pageSize) {
      this.query.currentNo = currentNo || this.query.currentNo
      this.query.pageSize = pageSize || this.query.pageSize
      // 选择弹框时控制每次加载3条
      if (this.type === 'select') {
        this.query.pageSize = 3
        this.query.status = '0'
      }
      api.myStore.getWarehouseData(this.query).then(res => {
        this.warehouseData = res.data.rows || []
        this.pageData = res.data
        if (this.selectedRowId && this.warehouseData.length) {
          this.handleChangeSelectRow(this.warehouseData[0], this.selectedRowId)
        }
        this.type === 'select' && (this.pageData.pageSize = 3)
      })
    },
    handleReset () {
      this.query = new Query()
      this.type === 'select' ? this.fetchList(1, 3) : this.fetchList(1)
    },
    toCreate (type, row) {
      this.callCreate.visible = true
      this.callCreate.type = type
      this.callCreate.detailInfo = row
    },
    toDelete (row) {
      this.$confirm('此操作将永久删除该仓库信息, 是否继续?', '提示', {
      }).then(() => {
        api.myStore.deleteWarehouse(row.id).then(res => {
          this.$message.success('操作成功')
          this.fetchList(this.query.currentNo)
        })
      }).catch(() => {

      })
    },

  },
}
</script>

<style lang="scss" scoped>

</style>
